import _ from 'lodash'

const templateTitleDebug = process.env.NODE_ENV === 'development' ? ' Returning:{panel.returning},Caretaker:{panel.caretaker}' : ''

const getContactWizardHelpPropsData = (helpTextKey, options = {}) => {
    return ({ $store }) => {
        return {
            hint: {
                title: 'Help Message',
                message: $store.getters.getScheduleHelpText(helpTextKey),
            },
            hideNext: options?.hideNext || false,
            mode: options?.mode || 'default',
        }
    }
}

const getContactMethodPropsData = (aep) => {
    return ({ $store, question }) => {
        // eslint-disable-next-line camelcase
        const allowed_methods = question.survey.valuesHash?.allowed_methods || []
        const choices = []
        if (allowed_methods.includes('email')) {
            choices.push({ title: 'E-mail', value: 'email', icon: 'envelope' })
        }
        if (allowed_methods.includes('phone')) {
            choices.push({ title: 'Phone', value: 'phone', icon: 'phone' })
        }
        if (allowed_methods.includes('video')) {
            choices.push({ title: 'Video Call', value: 'video', icon: 'video' })
        }
        if (allowed_methods.includes('survey') && aep) {
            choices.push({ title: 'AEP Survey', value: 'survey', icon: 'link' })
        }
        return {
            choices,
        }
    }
}

const getSoasPropsData = () => {
    return ({ question }) => {
        const attendee0 = _.cloneDeep(_.omit(question.survey.valuesHash, ['attendees']))
        const otherAttendees = question.survey.valuesHash.adding_attendees ? (_.cloneDeep(question.survey.valuesHash.attendees || [])) : []
        otherAttendees.forEach((attendee) => {
            if (!attendee.returning) {
                attendee.phone = attendee.phone || attendee0.phone
                attendee.email = attendee.email || attendee0.email
            }
            if (!attendee.returning && !attendee0.caretaker) {
                attendee.zip_code = attendee.zip_code || attendee0.zip_code
                attendee.state = attendee.state || attendee0.state
                if (attendee.zip_code === attendee0.zip_code) {
                    attendee.fips = attendee0.fips
                }
            }
        })
        return {
            client: question.survey.valuesHash,
            attendees: otherAttendees || [],
            addingAttendees: question.survey.valuesHash.adding_attendees,
            aep: question.survey.valuesHash.aep,
            titleClass: 'text-warning'
        }
    }
}

const getBookPropsData = () => {
    return ({ question }) => {
        const attendee0 = _.cloneDeep(_.omit(question.survey.valuesHash, ['attendees']))
        if (!attendee0.returning) {
            delete attendee0.token
        }
        const otherAttendees = question.survey.valuesHash.adding_attendees ? (_.cloneDeep(question.survey.valuesHash.attendees || [])) : []
        otherAttendees.forEach((attendee) => {
            if (!attendee.returning) {
                delete attendee.token
                attendee.phone = attendee.phone || attendee0.phone
                attendee.email = attendee.email || attendee0.email
            }
            if (!attendee.returning && !attendee0.caretaker) {
                attendee.zip_code = attendee.zip_code || attendee0.zip_code
                if (attendee.zip_code === attendee0.zip_code) {
                    attendee.fips = attendee0.fips
                }
                attendee.effective_date = attendee.effective_date || attendee0.effective_date
                attendee.source_name = attendee.source_name || attendee0.source_name
                attendee.source_type = attendee.source_type || attendee0.source_type
                attendee.group = attendee.group || (attendee0.group?.id || attendee0.group)
            }
        })

        // eslint-disable-next-line prefer-const
        let method = attendee0.method || question.survey.valuesHash.method
        const aep = question.survey.valuesHash.aep

        // temporary disable video for non aep
        // if (aep !== false && method === 'video') {
        //     method = 'phone'
        // }

        return {
            method,
            aep,
            notes: attendee0.notes || question.survey.valuesHash.notes,
            agent: question.survey.valuesHash.agent,
            attendees: [
                _.omit(attendee0, ['method', 'notes']),
                ...otherAttendees
            ],
            inWizard: true,
        }
    }
}

const surveyJson = {
    showPageNumbers: false,
    showQuestionNumbers: 'off',
    questionDescriptionLocation: 'underInput',
    questionErrorLocation: 'bottom',
    questionTitlePattern: 'numTitle',
    showProgressBar: 'off',
    _showProgressBar: 'top',
    progressBarType: 'pages',
    goNextPageAutomatic: false,
    calculatedValues: [
        {
            name: 'yearMinus2',
            expression: 'getter("yearMinus2")'
        },
        {
            name: 'emailOptInText',
            expression: 'getter("scheduleHelpTextEmailOptIn")'
        },
        {
            name: 'canAgent',
            expression: 'getter("canAgent")'
        },
        {
            name: 'isAEPScheduling',
            expression: 'getter("isAEPScheduling")'
        },
        {
            name: 'cannotAgent',
            expression: '!getter("canAgent")'
        },
        {
            name: 'isGroupForceReferral',
            expression: 'getter("isGroupForceReferral")',
        },
        {
            name: 'groupName',
            expression: 'getter("groupName")'
        },
        {
            name: 'preferredFirstName',
            expression: 'preferredFirstName()'
        },
        {
            name: 'hasOtherNewAttendees',
            expression: 'hasOtherNewAttendees()'
        },
        {
            name: 'hasAnyReturning',
            expression: 'hasAnyReturning()'
        },
        {
            name: 'bookingTitle',
            expression: 'x("this?.survey?.valuesHash?.method === \\"email\\" || this?.survey?.valuesHash?.method === \\"survey\\" ? \\"Email Consultation\\" : \\"Select Date & Time\\"")'
        },
        {
            name: 'multiContactMethod',
            expression: 'x("this?.survey?.valuesHash?.allowed_methods?.length > 1")'
        },
        {
            name: 'oneContactMethod',
            expression: 'x("this?.survey?.valuesHash?.allowed_methods?.length === 1")'
        },
        {
            name: 'noContactMethod',
            expression: 'x("!this?.survey?.valuesHash?.allowed_methods?.length")'
        },
        {
            name: 'canContact',
            expression: 'x("!!this?.survey?.valuesHash?.allowed_methods?.length")'
        },
        {
            name: 'cannotContact',
            expression: 'x("!this?.survey?.valuesHash?.allowed_methods?.length")'
        },
        {
            name: 'isPayingGroupReferral',
            expression: 'isPayingGroupReferral()'
        },
        {
            name: 'isNotPayingGroupReferral',
            expression: 'isNotPayingGroupReferral()'
        },
        {
            name: 'isUrlGroupReferral',
            expression: 'isUrlGroupReferral()'
        },
        {
            name: 'isNotUrlGroupReferral',
            expression: 'isNotUrlGroupReferral()'
        },
        {
            name: 'allClientsHaveSoas60days',
            expression: 'allClientsHaveSoas60days()'
        },
        {
            name: 'allClientsHaveSoas',
            expression: 'allClientsHaveSoas()'
        }
    ],
    pages: [
        {
            name: 'initial_page_group_referral',
            visibleIf: '{isUrlGroupReferral} = true',
            displayName: 'Start',
            hint: {
                title: 'Help Message',
                // message: 'This is an example of some explanation of feature, data we collect',
                returning: "Great! Let's look up your information",
                returningAttendee: n => `Great! We will look up ${n}'s information on the next page.`,
                nonReturningAttendee: n => `We will ask more information about ${n} on the next couple of pages.`,
                nonReturning: 'Do not worry! We will help you every step of the way!',
                // link: 'some link'
            },
            elements: [
                {
                    type: 'panel',
                    name: 'your_name_panel',
                    elements: [
                        {
                            visibleIf: '{isAEPScheduling}',
                            title: 'Are you currently on Medicare and looking to review your coverage during the Medicare Annual Enrollment Period?',
                            type: 'vcomponent',
                            name: 'aep',
                            component: 'survey/Choices',
                            isRequired: true,
                            skipClasses: true,
                            propsData: ({ $store, $route }) => {
                                return {
                                    choices: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
                                }
                            }
                        },
                        {
                            type: 'html',
                            visibleIf: '{isNotPayingGroupReferral} = true',
                            name: 'important_schedule_notice',
                            html: "<div class='alert alert-info border'><p>📣 <strong>Important Notice:</strong> Doctor's Choice partners with employers and financial advisors to provide trusted Medicare guidance and support. Our program is available exclusively to employees, retirees, and their family members from participating companies, as well as clients of our advisor partners.</p></div>"
                        },
                        {
                            type: 'vcomponent',
                            name: 'returning',
                            component: 'survey/Choices',
                            title: 'Have you worked with us before?',
                            description: 'Or have a login account with us.',
                            skipClasses: true,
                            isRequired: true,
                            propsData: () => {
                                return {
                                    choices: [
                                        {
                                            title: 'Yes',
                                            value: true
                                        },
                                        {
                                            title: 'No',
                                            value: false
                                        },
                                    ]
                                }
                            }
                        },
                    ]
                },
            ]
        },
        {
            name: 'start_page_non_group_referral',
            displayName: 'Start',
            visibleIf: '{isUrlGroupReferral} = false',
            hint: {
                title: 'Help Message',
                // message: 'This is an example of some explanation of feature, data we collect',
                returning: "Great! Let's look up your information",
                returningAttendee: n => `Great! We will look up ${n}'s information on the next page.`,
                nonReturningAttendee: n => `We will ask more information about ${n} on the next couple of pages.`,
                nonReturning: 'Do not worry! We will help you every step of the way!',
                // link: 'some link'
            },
            elements: [
                {
                    type: 'panel',
                    name: 'your_group_panel',
                    elements: [
                        {
                            visibleIf: '{isAEPScheduling}',
                            title: 'Are you currently on Medicare and looking to review your coverage during the Medicare Annual Enrollment Period?',
                            type: 'vcomponent',
                            name: 'aep',
                            component: 'survey/Choices',
                            isRequired: true,
                            skipClasses: true,
                            propsData: ({ $store, $route }) => {
                                return {
                                    choices: [{ title: 'Yes', value: true }, { title: 'No', value: false }],
                                }
                            }
                        },
                        {
                            type: 'html',
                            visibleIf: '{isNotPayingGroupReferral} = true',
                            name: 'important_schedule_notice',
                            html: "<div class='alert alert-info border'><p>📣 <strong>Important Notice:</strong> Doctor's Choice partners with employers and financial advisors to provide trusted Medicare guidance and support. Our program is available exclusively to employees, retirees, and their family members from participating companies, as well as clients of our advisor partners.</p></div>"
                        },
                        {
                            type: 'vcomponent',
                            name: 'returning',
                            component: 'survey/Choices',
                            title: 'Have you worked with us before?',
                            description: 'Or have a login account with us?',
                            skipClasses: true,
                            isRequired: true,
                            propsData: () => {
                                return {
                                    choices: [
                                        {
                                            title: 'Yes',
                                            value: true
                                        },
                                        {
                                            title: 'No',
                                            value: false
                                        },
                                    ]
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND {isGroupForceReferral} = false',
                            name: 'source_type',
                            title: 'Were you referred to us by an/a',
                            type: 'vcomponent',
                            component: 'GenericSelect',
                            skipClasses: true,
                            isRequired: true,
                            propsData: () => {
                                return {
                                    url: '/api/consults/survey/source-types/'
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND ({source_type} = "FAMILY_MEMBER")',
                            type: 'html',
                            name: 'family_member_notice',
                            html: "<div class='alert alert-info border'><p>Doctor's Choice is available to family members of employees from participating employers. To help us better assist you, please provide the name of the employer of the family member who referred you.</p></div>"
                        },
                        {
                            visibleIf: '{returning} = false AND {canAgent} = false AND ({source_type} = "EMPLOYER" OR {source_type} = "FAMILY_MEMBER")',
                            type: 'vcomponent',
                            name: 'group',
                            component: 'schedule/GroupFind',
                            skipClasses: true,
                            title: 'Please enter the full name of the employer',
                            propsData: ({ question }) => {
                                return {
                                    initialQuery: question.survey.valuesHash.group_query || '',
                                    minQuery: 3,
                                    nonParticipatingAlert: true,
                                    btnLabel: 'Find & Verify Employer',
                                    levels: ['paying']
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND {canAgent} = false AND {source_type} = "FINANCIAL_ADVISOR"',
                            type: 'vcomponent',
                            name: 'group',
                            component: 'schedule/GroupFind',
                            skipClasses: true,
                            title: 'Please enter the full name of the financial advisor',
                            propsData: ({ question }) => {
                                return {
                                    initialQuery: question.survey.valuesHash.group_query || '',
                                    minQuery: 3,
                                    nonParticipatingAlert: true,
                                    btnLabel: 'Find & Verify Financial Advisor',
                                    levels: ['financial_advisor']
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND {canAgent} = false AND {source_type} = "DIRECT_PRIMARY_CARE"',
                            type: 'vcomponent',
                            name: 'group',
                            component: 'schedule/GroupFind',
                            skipClasses: true,
                            title: 'Please enter the full name of the direct primary care doctor',
                            propsData: ({ question }) => {
                                return {
                                    initialQuery: question.survey.valuesHash.group_query || '',
                                    minQuery: 3,
                                    nonParticipatingAlert: true,
                                    btnLabel: 'Find & Verify Direct Primary Care',
                                    levels: ['dpc']
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND {canAgent} = true AND ({source_type} = "EMPLOYER" OR {source_type} = "FAMILY_MEMBER")',
                            type: 'vcomponent',
                            name: 'group',
                            component: 'schedule/GroupSelect',
                            skipClasses: true,
                            title: 'Please enter the full name of the employer/group',
                            propsData: () => {
                                return {
                                    minQuery: 0
                                }
                            }
                        },
                        {
                            visibleIf: '{returning} = false AND {source_type} = "DIRECT_PRIMARY_CARE"',
                            type: 'text',
                            name: 'source_name',
                            title: 'Please provide the name of direct primary care doctor that referred you',
                            isRequired: true,
                            validators: [{
                                type: 'text',
                                maxLength: 100,
                            }]
                        },
                    ]
                },
            ]
        },
        {
            name: 'verification',
            visibleIf: '{returning} = false ',
            elements: [
                {
                    titleLocation: 'hidden',
                    visibleIf: '{returning} = false',
                    type: 'vcomponent',
                    name: 'allowed_methods',
                    component: 'schedule/AllowedMethods',
                    propsData: ({ question }) => {
                        return {
                            client: question.survey.valuesHash,
                            forGroup: question.survey.valuesHash.group,
                            aep: question.survey.valuesHash.aep,
                            autoAdvance: true,
                        }
                    },
                }

            ]
        },
        {
            name: 'your_name',
            elements: [
                {
                    type: 'panel',
                    name: 'client_name_panel',
                    title: 'What is your full name?',
                    visibleIf: '{returning} = false AND {canContact} = true',
                    elements: [
                        {
                            type: 'text',
                            name: 'first_name',
                            startWithNewLine: false,
                            title: 'First',
                            xtitleLocation: 'hidden',
                            isRequired: true,
                            width: '40%',
                            minWidth: '40%',
                            maxWidth: '40%',
                            placeHolder: 'First'
                        },
                        {
                            type: 'text',
                            name: 'middle_name',
                            startWithNewLine: true,
                            title: 'Middle',
                            xtitleLocation: 'hidden',
                            placeHolder: 'Middle',
                            width: '20%',
                            minWidth: '20%',
                            maxWidth: '20%',
                            defaultValue: ''
                        },
                        {
                            type: 'text',
                            name: 'last_name',
                            title: 'Last',
                            xtitleLocation: 'hidden',
                            width: '40%',
                            minWidth: '40%',
                            maxWidth: '40%',
                            startWithNewLine: true,
                            isRequired: true,
                            placeHolder: 'Last'
                        },
                    ]
                },
                {
                    visibleIf: '{canContact} = true',
                    type: 'vcomponent',
                    name: 'adding_attendees',
                    component: 'survey/Choices',
                    title: 'Is anyone else joining you for the consultation?',
                    description: 'Please include any spouse or dependent needing Medicare guidance as an attendee, even if they won\'t join the consultation.',
                    skipClasses: true,
                    isRequired: true,
                    propsData: () => {
                        return {
                            choices: [
                                {
                                    title: 'Yes',
                                    value: true
                                },
                                {
                                    title: 'No',
                                    value: false
                                },
                            ]
                        }
                    }
                },
                {
                    type: 'panel',
                    name: 'add_attendees_panel',
                    visibleIf: '{adding_attendees} = true',
                    elements: [
                        {
                            type: 'paneldynamic',
                            name: 'attendees',
                            title: 'Please enter all attendees you would like to attend the consultation with you',
                            allowAddPanel: true,
                            allowRemovePanel: true,
                            panelRemoveButtonLocation: 'bottom',
                            panelCount: 1,
                            panelAddText: '+ Click here to add another attendee',
                            panelRemoveText: 'X Remove Attendee',
                            tabAlign: 'left',
                            templateTabTitle: '({panelIndex}) {panel.first_name}',
                            templateTitle: 'Attendee #{panelIndex}',
                            templateElements: [
                                {
                                    name: 'first_name',
                                    type: 'text',
                                    title: 'First',
                                    width: '40%',
                                    minWidth: '40%',
                                    maxWidth: '40%',
                                    isRequired: true,
                                },
                                {
                                    name: 'middle_name',
                                    type: 'text',
                                    title: 'Middle',
                                    startWithNewLine: true,
                                    width: '20%',
                                    minWidth: '20%',
                                    maxWidth: '20%',
                                },
                                {
                                    name: 'last_name',
                                    type: 'text',
                                    title: 'Last',
                                    startWithNewLine: true,
                                    width: '40%',
                                    minWidth: '40%',
                                    maxWidth: '40%',
                                    isRequired: true,
                                },
                                {
                                    type: 'vcomponent',
                                    component: 'GenericSelect',
                                    name: 'relationship',
                                    title: 'Relationship',
                                    propsData: () => {
                                        return {
                                            choices: [
                                                { text: 'Spouse', value: 'SPOUSE' },
                                                { text: 'Parent', value: 'PARENT' },
                                                { text: 'Child', value: 'CHILD' },
                                                { text: 'Friend', value: 'FRIEND' },
                                                { text: 'Other', value: 'OTHER' },
                                            ],
                                        }
                                    }
                                },
                                {
                                    name: 'caretaker',
                                    type: 'vcomponent',
                                    component: 'survey/Choices',
                                    skipClasses: true,
                                    title: 'Will {panel.first_name} need Medicare guidance?',
                                    visibleIf: '{panel.first_name} notempty',
                                    colCount: 0,
                                    startWithNewLine: true,
                                    isRequired: true,
                                    propsData: () => {
                                        return {
                                            choices: [
                                                {
                                                    value: false,
                                                    title: 'Yes'
                                                },
                                                {
                                                    value: true,
                                                    title: 'No'
                                                }
                                            ],
                                        }
                                    },
                                },
                                {
                                    type: 'vcomponent',
                                    component: 'survey/Choices',
                                    skipClasses: true,
                                    startWithNewLine: false,
                                    isRequired: true,
                                    name: 'returning',
                                    title: 'Has {panel.first_name} worked with us before?',
                                    visibleIf: '{panel.first_name} notempty AND {panel.caretaker} = false',
                                    colCount: 0,
                                },
                            ],
                        }
                    ]
                },
            ]
        },
        {
            name: 'contact_page',
            displayName: 'your_information',
            category: 'Determine your eligibility',
            hint: {
                title: 'Help Message',
                message: 'All of your information will be kept confidential and will not be shared with any third party',
            },
            elements: [
                {
                    type: 'panel',
                    name: 'client_contact_panel',
                    title: 'Your Information',
                    elements: [
                        {
                            visibleIf: '{returning} = true',
                            type: 'text',
                            name: 'email',
                            title: 'Your email address',
                            placeHolder: 'jane.doe@example.com',
                            isRequired: true,
                            validators: [{
                                type: 'email'
                            }]
                        },
                        {
                            visibleIf: '{returning} = true',
                            type: 'text',
                            name: 'dob',
                            title: 'Your date of birth',
                            startWithNewLine: true,
                            isRequired: true,
                            inputType: 'date',
                            max: new Date().toISOString().split('T')[0],
                            min: '1900-01-01',
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'text',
                            name: 'email',
                            title: 'Your email address',
                            placeHolder: 'jane.doe@example.com',
                            description: '{emailOptInText}',
                            isRequired: true,
                            addClasses: ['mb-3'],
                            validators: [{
                                type: 'email'
                            }]
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'panel',
                            name: 'phonePanel',
                            startWithNewLine: true,
                            addClasses: ['mb-3'],
                            elements: [
                                {
                                    type: 'text',
                                    name: 'phone',
                                    title: 'Your phone number',
                                    placeHolder: '555 444 3333 ext 123',
                                    isRequired: true,
                                    startWithNewLine: true,
                                    validators: [{
                                        type: 'text',
                                        minLength: 10,
                                    }]
                                },
                                {
                                    type: 'boolean',
                                    name: 'sms_opt_in',
                                    defaultValue: true,
                                    labelTrue: 'I allow Doctor\'s Choice to send text messages to this number',
                                    titleLocation: 'hidden'
                                }
                            ]
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'text',
                            name: 'dob',
                            title: 'Your date of birth',
                            description: 'This helps us give you accurate guidance. Your birth date will be kept confidential and will not be shared.',
                            isRequired: true,
                            inputType: 'date',
                            addClasses: ['mb-3'],
                            max: new Date().toISOString().split('T')[0],
                            min: '1900-01-01',
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'radiogroup',
                            name: 'gender',
                            title: 'What is your birth gender?',
                            description: 'As it\'s set on your birth certificate (required by Medicare.gov)',
                            startWithNewLine: true,
                            isRequired: true,
                            addClasses: ['mb-3'],
                            choices: [
                                {
                                    value: 'F',
                                    text: 'Female'
                                },
                                {
                                    value: 'M',
                                    text: 'Male'
                                }
                            ]
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'vcomponent',
                            name: 'location',
                            component: 'survey/Location',
                            title: 'What is your zip code?',
                            skipClasses: true,
                            pick: 'fips,zip_code,state',
                            isRequired: true,
                            addClasses: ['mb-3'],
                            propsData: () => {
                                return {
                                    inputClass: 'pb-0 mb-0',
                                    groupClass: 'pb-0 mb-0',
                                }
                            },
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'text',
                            name: 'effective_date',
                            title: 'When do you need coverage to start?',
                            startWithNewLine: true,
                            inputType: 'date',
                            addClasses: ['mb-3'],
                        },
                        {
                            type: 'radiogroup',
                            name: 'medicare_parts',
                            visibleIf: '{returning} = false',
                            title: 'Do you currently have any parts of Medicare?',
                            isRequired: true,
                            choices: [
                                {
                                    value: 'A',
                                    text: 'I only have part A'
                                },
                                {
                                    value: 'AB',
                                    text: 'I have both Medicare Part A and Part B'
                                },
                                {
                                    value: 'NONE',
                                    text: 'I do not have Medicare Part A or Part B'
                                },
                                {
                                    value: 'UNSURE',
                                    text: "I'm not sure"
                                }
                            ]
                        },
                    ]
                },
                {
                    type: 'panel',
                    name: 'attendees_contact_panel',
                    visibleIf: '{adding_attendees} = true',
                    elements: [
                        {
                            type: 'paneldynamic',
                            allowAddPanel: false,
                            allowRemovePanel: false,
                            name: 'attendees',
                            title: 'Attendees\'s Information',
                            tabAlign: 'left',
                            templateTabTitle: '({panelIndex}) {panel.first_name}',
                            templateTitle: '{panel.first_name}\'s Information ',
                            templateElements: [
                                {
                                    visibleIf: '{panel.returning} = true',
                                    type: 'text',
                                    name: 'email',
                                    title: '{panel.first_name}\'s email address',
                                    placeHolder: 'jane.doe@example.com',
                                    isRequired: true,
                                    validators: [{
                                        type: 'email'
                                    }]
                                },
                                {
                                    visibleIf: '{panel.returning} = true AND {panel.caretaker} = false',
                                    type: 'text',
                                    name: 'dob',
                                    title: 'What is {panel.first_name}\'s date of birth?',
                                    startWithNewLine: true,
                                    isRequired: true,
                                    inputType: 'date',
                                    max: new Date().toISOString().split('T')[0],
                                    min: '1900-01-01',
                                },
                                {
                                    visibleIf: '{panel.returning} = false OR {panel.caretaker} = true',
                                    type: 'text',
                                    name: 'email',
                                    title: '{panel.first_name}\'s email address',
                                    placeHolder: 'jane.doe@example.com',
                                    description: 'You can leave it blank if it\'s the same as yours. {emailOptInText}',
                                    addClasses: ['mb-3'],
                                    validators: [{
                                        type: 'email'
                                    }]
                                },
                                {
                                    visibleIf: '{panel.returning} = false OR {panel.caretaker} = true',
                                    type: 'panel',
                                    name: 'phonePanel',
                                    startWithNewLine: true,
                                    addClasses: ['mb-3'],
                                    elements: [
                                        {
                                            type: 'text',
                                            name: 'phone',
                                            title: '{panel.first_name}\'s phone number',
                                            isRequired: true,
                                            placeHolder: '555 444 3333 ext 123',
                                            validators: [{
                                                type: 'text',
                                                minLength: 10,
                                            }]
                                        },
                                        {
                                            visibleIf: '{panel.caretaker} = false',
                                            type: 'boolean',
                                            name: 'sms_opt_in',
                                            defaultValue: true,
                                            labelTrue: '{panel.first_name} allows Doctor\'s Choice to send text messages to this number',
                                            titleLocation: 'hidden'
                                        }
                                    ]
                                },
                                {
                                    visibleIf: '{panel.returning} = false AND {panel.caretaker} = false',
                                    type: 'text',
                                    name: 'dob',
                                    title: 'What is {panel.first_name}\'s date of birth?',
                                    description: 'This helps us give you accurate guidance. {panel.first_name}\'s birth date will be kept confidential and will not be shared.',
                                    isRequired: true,
                                    inputType: 'date',
                                    addClasses: ['mb-3'],
                                    max: new Date().toISOString().split('T')[0],
                                    min: '1900-01-01',
                                },
                                {
                                    visibleIf: '{panel.returning} = false AND {panel.caretaker} = false',
                                    type: 'radiogroup',
                                    name: 'gender',
                                    title: 'What is {panel.first_name}\'s birth gender?',
                                    description: 'As it\'s set on {panel.first_name}\'s birth certificate (required by Medicare.gov)',
                                    startWithNewLine: true,
                                    isRequired: true,
                                    addClasses: ['mb-3'],
                                    choices: [
                                        {
                                            value: 'F',
                                            text: 'Female'
                                        },
                                        {
                                            value: 'M',
                                            text: 'Male'
                                        }
                                    ]
                                },
                                {
                                    visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                                    type: 'vcomponent',
                                    name: 'location',
                                    component: 'survey/Location',
                                    title: '{panel.first_name}\'s Zip Code',
                                    skipClasses: true,
                                    pick: 'fips,zip_code,state',
                                    description: 'You can leave it blank if it\'s the same as yours',
                                    addClasses: ['mb-3'],
                                    propsData: () => {
                                        return {
                                            required: false,
                                            inputClass: 'pb-0 mb-0',
                                            groupClass: 'pb-0 mb-0',
                                        }
                                    },
                                },
                                {
                                    visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                                    type: 'text',
                                    name: 'effective_date',
                                    title: 'When does {panel.first_name} need coverage to start?',
                                    startWithNewLine: true,
                                    inputType: 'date',
                                    description: 'You can leave it blank if it\'s the same as yours',
                                    addClasses: ['mb-3'],
                                },
                                {
                                    visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                                    type: 'radiogroup',
                                    name: 'medicare_parts',
                                    title: 'Does {panel.first_name} currently have any parts of Medicare?',
                                    isRequired: true,
                                    choices: [
                                        {
                                            value: 'A',
                                            text: '{panel.first_name} only have part A'
                                        },
                                        {
                                            value: 'AB',
                                            text: '{panel.first_name} have both Medicare Part A and Part B'
                                        },
                                        {
                                            value: 'NONE',
                                            text: '{panel.first_name} does not have Medicare Part A or Part B'
                                        },
                                        {
                                            value: 'UNSURE',
                                            text: '{panel.first_name} is not sure'
                                        }
                                    ]
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            name: 'verification',
            visibleIf: '{returning} = true',
            elements: [
                {
                    type: 'panel',
                    name: 'returning_token_panel',
                    elements: [
                        {
                            titleLocation: 'hidden',
                            type: 'vcomponent',
                            name: 'returning_tokens',
                            component: 'schedule/Token',
                            propsData: ({ question }) => {
                                return {
                                    client: question.survey.valuesHash,
                                    attendees: question.survey.valuesHash.attendees || [],
                                    addingAttendees: question.survey.valuesHash.adding_attendees,
                                    aep: question.survey.valuesHash.aep,
                                    autoAdvance: true,
                                }
                            },
                        }
                    ]
                }
            ]
        },
        {
            name: 'special_page',
            title: 'Special Circumstances',
            displayName: 'Special Circumstances',
            // hint: {
            //     title: 'Help Message',
            //     message: 'This is an example of some explanation of feature, data we collect',
            //     link: 'some link'
            // },
            elements: [
                {
                    type: 'panel',
                    name: 'referral_panel',
                    title: '',
                    visibleIf: '{returning} = false AND {isUrlGroupReferral} = true',
                    titleLocation: 'Hidden',
                    elements: [
                        {
                            type: 'panel',
                            name: 'referral_panel',
                            visibleIf: '{returning} = false',
                            elements: [
                                {
                                    visibleIf: '{returning} = false AND {isGroupForceReferral} = false',
                                    name: 'source_type',
                                    title: 'Were you referred to us by an/a',
                                    type: 'vcomponent',
                                    component: 'GenericSelect',
                                    skipClasses: true,
                                    isRequired: true,
                                    propsData: () => {
                                        return {
                                            url: '/api/consults/survey/source-types/'
                                        }
                                    }
                                },
                                {
                                    visibleIf: '{returning} = false AND {isGroupForceReferral} = false AND ({source_type} = "FRIEND" OR {source_type} = "FAMILY_MEMBER" OR {source_type} = "FINANCIAL_ADVISOR" OR {source_type} = "DOCTOR" OR {source_type} = "OTHER" OR ({source_type} = "EMPLOYER" AND {cannotAgent}))',
                                    type: 'text',
                                    name: 'source_name',
                                    title: 'Please specify',
                                    isRequired: false,
                                    disabledIf: '{source_opt_out} = true',
                                    validators: [{
                                        type: 'text',
                                        maxLength: 100,
                                    }]
                                },
                                {
                                    visibleIf: '{returning} = false AND {isGroupForceReferral} = false AND {source_type} = "FAMILY_FIRST"',
                                    type: 'text',
                                    name: 'source_name',
                                    title: 'Please provide the name of advocate that referred you',
                                    isRequired: false,
                                    disabledIf: '{source_opt_out} = true',
                                    validators: [{
                                        type: 'text',
                                        maxLength: 100,
                                    }]
                                },
                                {
                                    visibleIf: '{returning} = false AND {isGroupForceReferral} = false AND {source_type} = "DIRECT_PRIMARY_CARE"',
                                    type: 'text',
                                    name: 'source_name',
                                    title: 'Please provide the name of Direct Primary Care doctor that referred you',
                                    isRequired: true,
                                    validators: [{
                                        type: 'text',
                                        maxLength: 100,
                                    }]
                                },
                                {
                                    visibleIf: '{returning} = false AND {isGroupForceReferral} = false',
                                    type: 'boolean',
                                    name: 'source_opt_out',
                                    labelTrue: 'I prefer not to specify my referral information',
                                    titleLocation: 'Hidden',
                                    defaultValue: false,
                                    valueTrue: true,
                                    valueFalse: false,
                                },
                                {
                                    visibleIf: '{isGroupForceReferral}',
                                    name: 'source_name',
                                    type: 'text',
                                    title: 'Referred by',
                                    isRequired: false,
                                    enableIf: 'false'
                                },
                                {
                                    visibleIf: '{returning} = false AND {source_type} != "EMPLOYER" AND {canAgent}',
                                    type: 'vcomponent',
                                    name: 'source_client',
                                    component: 'schedule/ClientSelect',
                                    skipClasses: true,
                                    title: 'Referral Client',
                                },
                                {
                                    visibleIf: '{canAgent} and {source_client} notempty',
                                    type: 'html',
                                    name: 'source_client_id',
                                    html: '<pre>Referral Client ID: {source_client}</pre>'
                                },
                                {
                                    visibleIf: '{returning} = false AND {source_type} = "EMPLOYER" AND {canAgent}',
                                    type: 'vcomponent',
                                    name: 'group',
                                    component: 'schedule/GroupSelect',
                                    skipClasses: true,
                                    title: 'Employer group',
                                },
                                {
                                    visibleIf: '{canAgent} and {group} notempty',
                                    type: 'html',
                                    name: 'group_id',
                                    html: '<pre>Group ID: {group}</pre>'
                                },
                                {
                                    visibleIf: '{returning} = false AND {source_type} = "EMPLOYER" AND {canAgent}',
                                    type: 'text',
                                    name: 'source_name',
                                    title: 'Can\'t find your group? Enter it manually',
                                },
                                {
                                    visibleIf: '{returning} = false AND {source_type} = "EMPLOYER" AND {canAgent}',
                                    type: 'vcomponent',
                                    component: 'GenericSelect',
                                    name: 'group_relationship',
                                    title: 'Group relationship',
                                    propsData: () => {
                                        return {
                                            choices: [
                                                { text: 'Employee', value: 'EMPLOYEE' },
                                                { text: 'Spouse of employee', value: 'EMPLOYEE_SPOUSE' },
                                                { text: 'Dependant of employee', value: 'EMPLOYEE_DEPENDENT' },
                                                { text: 'Parent of employee', value: 'EMPLOYEE_PARENT' },
                                                { text: 'Other relative of employee', value: 'OTHER_RELATIVE' },
                                                { text: 'Acquaintance of employee', value: 'ACQUAINTANCE_OF_EMPLOYEE' },
                                                { text: 'Referred by client', value: 'REFERRED_BY_CLIENT' },
                                            ]
                                        }
                                    }
                                },
                            ]
                        },
                    ]
                },
                {
                    type: 'panel',
                    name: 'special_panel',
                    title: 'Do any of the following apply to you? Check all that apply.',
                    visibleIf: '{returning} = false',
                    elements: [
                        {
                            visibleIf: '{returning} = false',
                            name: 'hsa_account',
                            titleLocation: 'hidden',
                            type: 'boolean',
                            labelTrue: 'I contribute to a Health Savings Account(HSA)',
                            tooltip: 'A health savings account, or HSA, is a type of savings account that lets you set aside money on a pre-tax basis to pay for qualified medical expenses',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        // {
                        //     visibleIf: '{returning} = false and {hsa_account} = true',
                        //     type: 'boolean',
                        //     name: 'hsa',
                        //     labelTrue: 'I am actively contributing to my HSA account',
                        //     titleLocation: 'hidden',
                        //     defaultValue: false,
                        //     valueTrue: true,
                        //     valueFalse: false,
                        //     addClasses: ['border', 'rounded']
                        // },
                        {
                            visibleIf: '{returning} = false',
                            type: 'boolean',
                            name: 'collecting_ssi',
                            labelTrue: 'I am collecting Social Security or Railroad Retirement benefits',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'boolean',
                            name: 'moving',
                            labelTrue: 'I plan on moving to a different state within the next 12 months',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            name: 'moving_state',
                            type: 'vcomponent',
                            component: 'GenericSelect',
                            title: 'Which state are you moving to?',
                            visibleIf: '{returning} = false AND {moving} = true',
                            propsData: () => {
                                return {
                                    url: '/api/consults/survey/states/',
                                }
                            },
                            isRequired: true
                        },
                        {
                            visibleIf: '{returning} = false',
                            type: 'boolean',
                            name: 'multiple_states',
                            labelTrue: 'I plan on traveling out of state within the next 12 months',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },

                    ]
                },
                {
                    name: 'attendees',
                    visibleIf: '{adding_attendees} = true AND {hasOtherNewAttendees} = true',
                    type: 'paneldynamic',
                    allowAddPanel: false,
                    allowRemovePanel: false,
                    _title: 'Do any of the following apply to {panel.first_name}? Check all that apply.',
                    tabAlign: 'left',
                    templateTitle: `Do any of the following apply to {panel.first_name}? Check all that apply.${templateTitleDebug}`,
                    _templateTitle: `{panel.first_name} {panel.last_name}${templateTitleDebug}`,
                    templateElements: [
                        {
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                            type: 'boolean',
                            name: 'hsa_account',
                            labelTrue: '{panel.first_name} contributes to a Health Savings Account(HSA)',
                            tooltip: 'A health savings account, or HSA, is a type of savings account that lets you set aside money on a pre-tax basis to pay for qualified medical expenses',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false AND {panel.hsa_account} = true',
                            type: 'boolean',
                            name: 'hsa',
                            labelTrue: '{panel.first_name} is actively contributing to their HSA account',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                            type: 'boolean',
                            name: 'collecting_ssi',
                            labelTrue: '{panel.first_name} is collecting Social Security or Railroad Retirement benefits',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                            type: 'boolean',
                            name: 'moving',
                            labelTrue: '{panel.first_name} is planning on moving to a different state within the next 12 months',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                        {
                            type: 'vcomponent',
                            component: 'GenericSelect',
                            name: 'moving_state',
                            title: 'Which state is {panel.first_name} moving to?',
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false AND {panel.moving} = true',
                            propsData: () => {
                                return {
                                    url: '/api/consults/survey/states/',
                                }
                            },
                            isRequired: true
                        },
                        {
                            visibleIf: '{panel.caretaker} = false AND {panel.returning} = false',
                            type: 'boolean',
                            name: 'multiple_states',
                            labelTrue: '{panel.first_name} is planning on traveling out of state within the next 12 months',
                            titleLocation: 'hidden',
                            defaultValue: false,
                            valueTrue: true,
                            valueFalse: false,
                            addClasses: ['border', 'rounded']
                        },
                    ],
                }
            ]
        },
        {
            name: 'scope_of_appointment',
            displayName: 'Required Form',
            elements: [
                {
                    visibleIf: '{allClientsHaveSoas60days} = false and {canContact} = true',
                    type: 'vcomponent',
                    title: 'Scope of Appointment',
                    titleLocation: 'hidden',
                    component: 'schedule/Soas',
                    name: 'soas',
                    isRequired: true,
                    propsData: getSoasPropsData()
                },
            ]
        },
        {
            name: 'contact_method',
            displayName: 'Contact Method',
            title: 'Contact Method',
            elements: [
                {
                    type: 'panel',
                    name: 'method_panel',
                    elements: [
                        {
                            visibleIf: '{aep} != true and {canContact} = true',
                            title: 'What is your preferred contact method for the consultation?',
                            type: 'vcomponent',
                            name: 'method',
                            component: 'survey/Choices',
                            isRequired: true,
                            skipClasses: true,
                            propsData: getContactMethodPropsData(false),

                        },
                        {
                            visibleIf: '{aep} = true and {canContact} = true',
                            title: 'What is your preferred aep contact method for the consultation?',
                            type: 'vcomponent',
                            name: 'method',
                            component: 'survey/Choices',
                            isRequired: true,
                            skipClasses: true,
                            propsData: getContactMethodPropsData(true),
                        },
                    ]
                },
                {
                    visibleIf: '{method} = "survey" and {aep} = true and {oneContactMethod} = true',
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('email_only_in_aep'),
                },
                {
                    visibleIf: '{method} = "email" and {aep} != true and {oneContactMethod} = true',
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('email_only'),
                },
                {
                    visibleIf: '{noContactMethod}',
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('no_contact', { hideNext: true, mode: 'alert' }),
                },
                {
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    visibleIf: '{method} = "email" and {aep} != true and {multiContactMethod} = true',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('email'),
                },
                {
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    visibleIf: '{method} = "email" and {aep} = true and {multiContactMethod} = true',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('email_in_aep'),
                },
                {
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    visibleIf: '{method} = "phone" and {aep} != true and {multiContactMethod} = true',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('phone'),
                },
                // // hiding this because they are currently booked out:
                // // https://doctorschoice.slack.com/archives/C01JVB654MD/p1756741989801249
                // {
                //     titleLocation: 'hidden',
                //     type: 'vcomponent',
                //     name: 'contact_hint',
                //     component: 'WizardHelp',
                //     visibleIf: '{method} = "phone" and {aep} = true and {multiContactMethod} = true',
                //     skipClasses: true,
                //     propsData: getContactWizardHelpPropsData('phone_in_aep'),
                // },
                {
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    visibleIf: '{method} = "video" and {aep} != true and {multiContactMethod} = true',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('video'),
                },
                {
                    titleLocation: 'hidden',
                    type: 'vcomponent',
                    name: 'contact_hint',
                    component: 'WizardHelp',
                    visibleIf: '{method} = "survey" and {aep} = true and {multiContactMethod} = true',
                    skipClasses: true,
                    propsData: getContactWizardHelpPropsData('survey_in_aep'),
                },
                {
                    titleLocation: 'hidden',
                    visibleIf: '{method} = "survey" and {canContact} = true',
                    type: 'vcomponent',
                    name: 'book',
                    component: 'schedule/Book',
                    propsData: getBookPropsData(),
                },
                {
                    titleLocation: 'hidden',
                    visibleIf: '{method} = "email" and {canContact} = true',
                    type: 'vcomponent',
                    name: 'book',
                    component: 'schedule/Book',
                    propsData: getBookPropsData(),
                }
            ]
        },
        {
            visibleIf: '{method} != "survey" and {method} != "email" and {canContact} = true',
            name: 'book_page',
            displayName: 'Booking',
            elements: [
                {
                    // titleLocation: 'hidden',
                    type: 'vcomponent',
                    title: '{bookingTitle}',
                    name: 'book',
                    component: 'schedule/Book',
                    propsData: getBookPropsData(),
                }
            ]
        }
    ],
    triggers: [
        {
            type: 'runexpression',
            expression: '{canContact}',
            runExpression: 'updateContactMethodTitleLocation()'
        },
        {
            type: 'runexpression',
            expression: '{cannotContact}',
            runExpression: 'updateContactMethodTitleLocation()'
        },
        {
            type: 'setvalue',
            expression: "{source_type} != 'EMPLOYER' AND {source_type} != 'FINANCIAL_ADVISOR' AND {source_type} != 'FAMILY_MEMBER'",
            setToName: 'group',
            setValue: null
        },
        {
            type: 'setvalue',
            expression: "{source_type} == 'DOCTOR_CHOICE_INTERNAL'",
            setToName: 'allowed_methods',
            setValue: ['email', 'phone', 'video']
        }
    ]
}

export default surveyJson
